import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { getColorType } from 'utils/types';

import s from './ProgressBar.module.scss';

const cx = cn.bind(s);

const ProgressBar = ({
  className, progress, barTheme = '', classNames = {}, hasNumber = true, numberStyle, height, variant = '', labels, align = 'left', highlight = [], color = 'mint', ...attrs
}) => {
  const normalizedProgress = (Array.isArray(progress)
    ? progress : [progress]).map((score) => Math.round(score));
  const isSingle = normalizedProgress.length === 1;
  const maxValue = Math.max(...normalizedProgress);
  const leftNumberFilled = highlight[0] == null ? maxValue === progress[0] : highlight[0];
  const rightNumberFilled = highlight[1] == null ? maxValue === progress[1] : highlight[1];
  return (
    <div className={cx('wrapper', className, color)}>
      {labels && (
        <div className={cx('labels', classNames?.labels)}>
          {labels.map((label, index) => (
            <div
              key={label}
              className={cx('label', {
                filledLabel: highlight[index],
              })}
            >
              {label}
            </div>
          ))}
        </div>
      )}
      <div
        className={cx('progress')}
        style={{ '--progress-width': `${maxValue}%`, '--progress-height': height && `${height}px` }}
        {...attrs}
      >
        {hasNumber && (<span
          className={cx('number', {
            alignRight: isSingle && !labels?.[0],
            singleNumber: isSingle,
            innerNumber: numberStyle === 'in',
            numberFilled: leftNumberFilled,
          })}
        >
          {normalizedProgress[0]}%
        </span>) }
        <div
          className={cx('progressBar', {
            progressBarRight: align === 'right',
            fillWhite: barTheme === 'white',
            fillGrey: barTheme === 'grey',
            [`progressBar--variant-${variant}`]: variant,
          })}
        />
        {!isSingle && (
          <span
            className={cx('number', 'alignRight', {
              numberFilled: rightNumberFilled,
              innerNumber: numberStyle === 'in'
            })}
          >
            {normalizedProgress[1]}%
          </span>
        )}
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  color: getColorType(['brown', 'blue']),
  hasNumber: PropTypes.bool,
  barTheme: PropTypes.oneOf(['white', 'grey', '']),
  align: PropTypes.oneOf(['left', 'right']),
  progress: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]).isRequired,
  labels: PropTypes.arrayOf(PropTypes.string),
};

export default ProgressBar;
